import { Category } from "./Types/category.types";

export const initialCategory: Category = {
	id: 0,
	name: "",
	description: "",
	metaTitle: "",
	metaDescription: "",
	metaKeywords: "",
	showOnHomePage: false,
	includeInTopMenu: false,
	published: false,
	displayOrder: 0,
	parentCategoryId: null,
};
